<script setup lang="ts">
/**
 * APIローディング中表示用コンポーネント。
 */
</script>

<template>
	<section class="revico-api-loading--container">
		<div class="revico-api-loading--contents">
			<div class="revico-api-loading--ball-pulse">
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</section>
</template>

<style lang="scss">
.revico-widget {
	.revico-api-loading {
		&--container {
			position: relative;
			margin: 10px;
			height: 20px;
		}

		&--contents {
			background-color: #fff;
			opacity: 0.5;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
		}

		&--ball-pulse {
			text-align: center;
			margin-top: 0px;
			margin-left: -40px;
			position: absolute;
			width: 80px;
			left: 50%;
			top: 50%;
			z-index: 900;

			& > div {
				background-color: #aaa;
				width: 15px;
				height: 15px;
				border-radius: 100%;
				margin: 2px;
				-webkit-animation-fill-mode: both;
				-moz-animation-fill-mode: both;
				-ms-animation-fill-mode: both;
				animation-fill-mode: both;
				display: inline-block;
			}

			& > div:nth-child(1) {
				-webkit-animation-name: scaleAnimation;
				-webkit-animation-delay: -0.24s;
				-webkit-animation-duration: 0.75s;
				-webkit-animation-iteration-count: infinite;
				-moz-animation-name: scaleAnimation;
				-moz-animation-delay: -0.24s;
				-moz-animation-duration: 0.75s;
				-moz-animation-iteration-count: infinite;
				-ms-animation-name: scaleAnimation;
				-ms-animation-delay: -0.24s;
				-ms-animation-duration: 0.75s;
				-ms-animation-iteration-count: infinite;
				animation-name: scaleAnimation;
				animation-delay: -0.24s;
				animation-duration: 0.75s;
				animation-iteration-count: infinite;
			}

			& > div:nth-child(2) {
				-webkit-animation-name: scaleAnimation;
				-webkit-animation-delay: -0.12s;
				-webkit-animation-duration: 0.75s;
				-webkit-animation-iteration-count: infinite;
				-moz-animation-name: scaleAnimation;
				-moz-animation-delay: -0.12s;
				-moz-animation-duration: 0.75s;
				-moz-animation-iteration-count: infinite;
				-ms-animation-name: scaleAnimation;
				-ms-animation-delay: -0.12s;
				-ms-animation-duration: 0.75s;
				-ms-animation-iteration-count: infinite;
				animation-name: scaleAnimation;
				animation-delay: -0.12s;
				animation-duration: 0.75s;
				animation-iteration-count: infinite;
			}

			& > div:nth-child(3) {
				-webkit-animation-name: scaleAnimation;
				-webkit-animation-delay: 0s;
				-webkit-animation-duration: 0.75s;
				-webkit-animation-iteration-count: infinite;
				-moz-animation-name: scaleAnimation;
				-moz-animation-delay: 0s;
				-moz-animation-duration: 0.75s;
				-moz-animation-iteration-count: infinite;
				-ms-animation-name: scaleAnimation;
				-ms-animation-delay: 0s;
				-ms-animation-duration: 0.75s;
				-ms-animation-iteration-count: infinite;
				animation-name: scaleAnimation;
				animation-delay: 0s;
				animation-duration: 0.75s;
				animation-iteration-count: infinite;
			}
		}
	}
}
@-webkit-keyframes scaleAnimation {
	0% {
		-webkit-transform: scale(0.2);
	}

	100% {
		-webkit-transform: scale(1.2);
	}
}

@-moz-keyframes scaleAnimation {
	0% {
		-moz-transform: scale(0.2);
	}

	100% {
		-moz-transform: scale(1.2);
	}
}

@-ms-keyframes scaleAnimation {
	0% {
		-ms-transform: scale(0.2);
	}

	100% {
		-ms-transform: scale(1.2);
	}
}

@keyframes scaleAnimation {
	0% {
		transform: scale(0.2);
	}

	100% {
		transform: scale(1.2);
	}
}
</style>
